import React, { FC, useContext, useEffect, useState } from "react";
import { Box, Chip, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { ChipProps } from "../../interfaces";

import videoImage2 from "../../assets/images/videoimage2.png";
import Lock from "../../assets/images/Lock.svg";
import DoneIcon from "../../assets/images/clickIcon.svg";
import { AuthPoolQuiz, Quiz } from "../../store/Learn2/learn.interface";
import LearnContext from "../../store/Learn2/LearnContext";

interface LearnSidebarProps {
    quizzes: Quiz[];
    isActive: boolean;
    quizIndex: number;
    chip: string;
}

const LockIcon = () => {
    return <img src={Lock} alt="gains" />;
};

const EmptyIcon = () => {
    return <img src="" alt="" />;
};
const SuccessIcon = () => {
    return <img src={DoneIcon} alt="gains" />;
};

const LearnSidebar: FC<LearnSidebarProps> = (props) => {
    
    const { quizzes, isActive, quizIndex, chip } = props;

    const { activeQuizSubmissions, quizTracker } = useContext<any>(LearnContext);

    const currentQuizSubmissions = activeQuizSubmissions.filter((submission : any) => {
        return submission.quizId === quizTracker?.quiz_id && submission.poolId === quizTracker?.pool_id
    });

    const [totalScore, setTotalScore] = useState<number>(0);
    const [totalCorrect, setTotalCorrect] = useState<number>(0);

    useEffect(() => {
        currentQuizSubmissions.map((submissions: any) => {
            setTotalScore((prev) => prev + submissions.answerResponse.isCorrect);
            if (submissions.answerResponse.isCorrect) setTotalCorrect((prev) => prev + 1)
          });
    }, [])

    return (
        <Box component="section" maxWidth="1920px" position="relative">
            <Box
                mt={ isActive ? 3 : 5 }
                ml={ isActive ? 0 : 0 }
                className="videos-box-res scroller"
            >
                <Box display="flex" flexDirection="column" alignItems="center">
                    {
                        quizzes.sort((quiz1: Quiz, quiz2: Quiz) => {
                            if (quiz1.orderNumber < quiz2.orderNumber) return -1;
                            else return 1;
                        }).map((quiz: Quiz, i: any) => (
                            <React.Fragment key={i}>
                                {
                                    chip && quizIndex >= i 
                                    ?
                                    (
                                        <>
                                            <Box className="border-box" mb={ isActive ? 2 : 3 } key={i}>
                                                <Box display="flex" alignItems="center">
                                                    <Typography variant="h4" component="span" color="primary">
                                                        { i + 1 + ":" }
                                                    </Typography>
                                                    <Box>
                                                        <Chip
                                                            label={quiz.title.toUpperCase()}
                                                            className="chip-box chip-text"
                                                            deleteIcon={ quizIndex > i ? <SuccessIcon /> : <EmptyIcon /> }
                                                            onDelete={() => console.info("")}
                                                            // TODO: Add a conditional success icon
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box mt={1} mb={ isActive ? 2 : 3 }>
                                                    <img
                                                        src={quiz.image}
                                                        alt="GainsPad Quiz"
                                                        className="video-image img-fluid"
                                                    />
                                                    {
                                                        chip && quizIndex === i && (
                                                            <Box mt={1} mb={ isActive ? 2 : 3 }>
                                                                <Box display="flex" mt={1}>
                                                                    <Box
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    pr={1}
                                                                    mr={1}
                                                                    mb={isActive ? 0 : 0}
                                                                    className="v-line"
                                                                    >
                                                                    {" "}
                                                                    {/**flex box item */}
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        color="primary"
                                                                        className=" fw-bold"
                                                                    >
                                                                        { totalScore}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        className="body-color fw-normal"
                                                                    >
                                                                        Score
                                                                    </Typography>
                                                                    </Box>
                                                                    <Box
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    pr={1}
                                                                    mr={1}
                                                                    className="v-line"
                                                                    >
                                                                    {" "}
                                                                    {/**flex box item */}
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        color="primary"
                                                                        className=" fw-bold"
                                                                        component="span"
                                                                    >
                                                                        {quiz.question?.length}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        className="body-color fw-normal"
                                                                        component="span"
                                                                    >
                                                                        Total Questions
                                                                    </Typography>
                                                                    </Box>
                                                                    <Box display="flex" flexDirection="column">
                                                                    {" "}
                                                                    {/**flex box item */}
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        color="primary"
                                                                        className=" fw-bold"
                                                                    >
                                                                        { totalCorrect }
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        className="body-color fw-normal"
                                                                    >
                                                                        Correct
                                                                    </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        )
                                                    }
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                    :
                                    (
                                            <Box className="border-box" mb={isActive ? 2 : 3}>
                                                {/**item main flex box */}
                                                <Box display="flex" alignItems="center">
                                                    <Typography
                                                        variant="h4"
                                                        component="span"
                                                        className="chip-box"
                                                    >
                                                        {i + 1}.
                                                    </Typography>
                                                    <Box>
                                                        <Chip
                                                        label={quiz.title}
                                                        deleteIcon={
                                                            quizIndex >= i ? <EmptyIcon /> : <LockIcon />
                                                        }
                                                        onDelete={() => console.info()}
                                                        className="chip-box"
                                                        />
                                                    </Box>
                                                </Box>
                                            <Box mt={1} mb={isActive ? 2 : 3}>
                                            <img
                                                src={videoImage2}
                                                alt=""
                                                className="video-image img-fluid"
                                            />
                                            </Box>
                                        </Box>
                                    )
                                }
                            </React.Fragment>
                        ))
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default LearnSidebar;